export const createLeagues = (lastMatches) => {
    let leagueSet = new Set();
    if (lastMatches) {
        lastMatches.matches.map(match => {
            leagueSet.add(`${match.league.name}_${match.location.name}`);
            return '';
        });
    }
    return Array.from(leagueSet);
}